// extracted by mini-css-extract-plugin
export default {"showMoreButton":"ShowMoreButton_showMoreButton__KtNQ5","showMoreNumber":"ShowMoreButton_showMoreNumber__fi422"};